module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.isLoading,
      "size": 100,
      "height": true
    }
  }, [(_vm.isRequestExecuted) ? _c('FinishMessage', {
    attrs: {
      "message": _vm.message
    },
    on: {
      "understood": function($event) {
        return _vm.$emit("understood")
      }
    }
  }) : _c('RequestForm', {
    attrs: {
      "users": _vm.users,
      "errors": _vm.errors
    },
    on: {
      "submitRequest": _vm.submitRequest,
      "cancelRequest": _vm.cancelRequest
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f82ecdcc","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/request/EventRequestForm.vue
// module id = aa0cb318b93e201acc5b
// module chunks = 5